{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/comment-edit-link",
	"title": "Comment Edit Link",
	"category": "theme",
	"ancestor": [ "core/comment-template" ],
	"description": "Displays a link to edit the comment in the WordPress Dashboard. This link is only visible to users with the edit comment capability.",
	"textdomain": "default",
	"usesContext": [ "commentId" ],
	"attributes": {
		"linkTarget": {
			"type": "string",
			"default": "_self"
		},
		"textAlign": {
			"type": "string"
		}
	},
	"supports": {
		"html": false,
		"color": {
			"link": true,
			"gradients": true,
			"text": false,
			"__experimentalDefaultControls": {
				"background": true,
				"link": true
			}
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		}
	},
	"style": "wp-block-comment-edit-link"
}
